import { Input } from './input'
import { todayLocalDateString } from '@/lib/utils'

interface DateInputProps {
  value: string
  onChange: (value: string) => void
  className?: string
}

/** Date field used on the add/edit expense forms. Defaults to disallowing future dates. */
export function DateInput({ value, onChange, className = 'w-36 h-11 text-sm' }: DateInputProps) {
  return (
    <Input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={className}
      max={todayLocalDateString()}
      required
    />
  )
}
